import { StatisticsTable } from '../../../components/core-v2'

export type Statistic = {
  maxDrawdown: number
  period: string
  return: number
  sharpe: number
  volatility: number
}

type StatisticsProps = {
  statistics: Statistic[]
}

export const StatisticsTab = ({ statistics }: StatisticsProps) => (
  <StatisticsTable statistics={statistics} />
)
